import { useMutation } from '@tanstack/react-query';

import { useInvalidateChannelsOfCompanyList } from '@/entities/company';
import {
  transferChannelToNewCompany,
  TTransferChannelToNewCompanyParamsDto,
} from '@/shared/api/companies';
import { useNotifications } from '@/shared/ui/Notifications';

interface ITransferChannelData {
  companyId: string;
  channelId: string;
  params: TTransferChannelToNewCompanyParamsDto;
}

export function useTransferChannelToNewCompany() {
  const { addNotification } = useNotifications();
  const invalidateChannelsOfCompanyList = useInvalidateChannelsOfCompanyList();

  const transferChannelMutation = useMutation({
    mutationFn: (data: ITransferChannelData) =>
      transferChannelToNewCompany(data.companyId, data.channelId, data.params),
  });

  const transferChannelToCompany = async (
    data: ITransferChannelData,
    onSuccess?: () => void
  ): Promise<void> => {
    return transferChannelMutation.mutateAsync(data, {
      onSuccess: () => {
        onSuccess?.();
        invalidateChannelsOfCompanyList(data.companyId);
      },
      onError: (error) => {
        addNotification({
          title: error.message,
          caption: error?.data?.details,
        });
      },
    });
  };

  return {
    transferChannelToCompany,
    ...transferChannelMutation,
  };
}
